// extracted by mini-css-extract-plugin
export default {"container":"BasicPageHeader_container__Q8JqU","leftContainer":"BasicPageHeader_leftContainer__Ys+Dp","rightContainer":"BasicPageHeader_rightContainer__lv52T"};